import { css } from '@emotion/react';

const StockChartStyles = css`
    position: relative;

    .highcharts-label-box {
        stroke: none;
        stroke-width: 0;
    }

    .highcharts-range-selector-buttons {
        transform: translate(0, 10px);
    }

    .highcharts-input-group {
        transform: translate(20px, 60px);
    }

    .custom-legend-wrapper {
        position: absolute;
        bottom: 2rem;
        right: 1rem;
        display: flex;

        .legend-dropdown-title {
            margin-right: 0.5rem;
        }

        #customSelect {
            .item.visible {
                background-color: lightgrey;
            }
        }
    }

    .highcharts-button-box {
        rx: 20;
        ry: 20;
        x: 5;
        y: -5;
        width: 30px;
        height: 30px;
    }

    .highcharts-tooltip {
        path {
            stroke: none;
            stroke-width: 0;
            fill: transparent;
        }

        .custom-point-container {
            position: absolute;
            top: 0;
            left: 2.5rem;
            display: flex;
            flex-direction: column;
            z-index: 1;

            .price-value,
            price-difference {
                font-size: 1.5rem;
                font-weight: 500;
            }
            .date {
                font-size: 0.8rem;
            }
        }
    }

    .growth-amount {
        position: absolute;
        bottom: 4rem;
        right: 1rem;
        display: flex;

        .growth-amount-feedback {
            color: red;
        }
    }
`;

export const themeStockChartStyles = css`
    .custom-legend-wrapper {
        font-family: var(--font-family-regular);
        font-weight: var(--font-weight-bold);
        font-size: var(--font-size-small);
        color: var(--default-text-color);

        #customSelect {
            .item.visible {
                background-color: var(--color-light-grey);
            }
        }
    }

    .custom-point-container {
        font-family: var(--font-family-regular);
        font-weight: var(--font-weight-bold);
        font-size: var(--font-size-small);
        color: var(--default-text-color);

        .price-value,
        price-difference {
            font-size: var(--font-size-large);
            font-weight: var(--font-weight-medium);
        }

        .date {
            font-size: var(--font-weight-medium);
        }
    }
`;

export default StockChartStyles;
